import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth0 } from "@auth0/auth0-react";
import AlphaCredentialsModal from './AlphaCredentialsModal';
import { REQUIRE_ALPHA_CREDENTIALS } from '../../config';



export default function Navbar() {

  const { logout, loginWithRedirect, isAuthenticated } = useAuth0();
  const [showCredentialsModal, setShowCredentialsModal] = useState(false);

  const handleSignOut = async () => {
    try {
      if (logout) {
        await logout({
          logoutParams: {
            returnTo: window.location.origin
          }
        });
        console.log('User signed out');
      } else {
        console.error('Auth0 logout method not available');
      }
    } catch (err) {
      console.error('Logout failed:', err);
    }
  };

  const handleSignIn = () => {
    if (REQUIRE_ALPHA_CREDENTIALS) {
      setShowCredentialsModal(true);
    } else {
      // Bypass alpha gate - go directly to Auth0
      handleProceedToLogin();
    }
  };

  const handleProceedToLogin = async () => {
    setShowCredentialsModal(false);
    
    try {
      if (loginWithRedirect) {
        const authParams = {
          authorizationParams: {
            redirect_uri: `${window.location.origin}/callback`,
          }
        };

        const organization_id = null; 

        if (organization_id) {
          authParams.authorizationParams.organization = organization_id;
        }

        console.log("Sign-in parameters:", authParams);

        await loginWithRedirect(authParams);
      } else {
        console.error('Auth0 not properly initialized');
      }
    } catch (err) {
      console.error('Login failed:', err);
    }
  };

  return (
    <nav className="w-full flex items-center justify-between px-2 py-3 md:px-6 bg-white shadow-sm sticky top-0 z-30">
      <div className="flex items-center gap-2">
        <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
          <svg className="w-5 h-5 text-white" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 4.75L19.25 9L12 13.25L4.75 9L12 4.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9.25 11.5L4.75 14L12 18.25L19.25 14L14.75 11.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        <span className="font-bold text-xl text-primary">ArcAttend</span>
      </div>
      <div className="hidden md:flex gap-8 text-gray-700 font-medium">
        <a href="#features" className="hover:text-blue-600">Features</a>
        <a href="#pricing" className="hover:text-blue-600">Pricing</a>
        <a href="#faqs" className="hover:text-blue-600">FAQs</a>
      </div>
      <div className="hidden md:flex gap-4 items-center">
        {!isAuthenticated ? (
          <>
            <button onClick={handleSignIn} className="text-gray-700 hover:text-blue-600">Sign in</button>
            <button onClick={handleSignIn} className="bg-blue-600 text-white px-4 py-2 rounded-full font-semibold hover:bg-blue-700 transition">Get started today</button>
          </>
        ) : (
          <>
            <Link to="/onboarding" className="text-gray-700 hover:text-blue-600">Create Organization</Link>
            <button 
              onClick={handleSignOut}
              className="text-gray-700 hover:text-blue-600"
            >
              Sign out
            </button>
          </>
        )}
      </div>
      {/* Mobile menu button */}
      <div className="md:hidden flex items-center">
        <button className="text-gray-700 focus:outline-none">
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" /></svg>
        </button>
      </div>

      {/* Alpha Credentials Modal */}
      <AlphaCredentialsModal
        isOpen={showCredentialsModal}
        onClose={() => setShowCredentialsModal(false)}
        onProceedToLogin={handleProceedToLogin}
      />
    </nav>
  );
} 
